import React from 'react';
import Radium from 'radium';
import Card from './components/Card';
import StyleDecorator from './components/StyleDecorator';
import Notice from './components/Notice';
import LandingPageLink from './components/links/LandingPageLink';
import translate from './locale/translate';
import SipgateFormHeaderLogo from './components/images/SipgateFormHeaderLogo';
import { browserHistory } from 'react-router';
import { paths } from './routes/index';
import Theme from './styles/theme';
import Button from './components/buttons/Button';


const ChangeEmailSuccessApp = () => {
	const style = {
		marginTop: '35px',
		backgroundColor: Theme.palette.primary1Color,
		':hover': {
			cursor: 'pointer',
		},
	};

	return (<Card
		header={<SipgateFormHeaderLogo />}
		footer={<LandingPageLink />}
	>
		<Notice>
			<h3 style={{ textAlign: 'center' }}>{translate('NOTICE_CHANGE_EMAIL_SUCCESS_HEADER')}</h3>
			<p>{translate('NOTICE_CHANGE_EMAIL_SUCCESS')}</p>
			<Button
				style={style}
				onTouchTap={() => browserHistory.push(paths.APP_ROOT)}
			>
				{translate('LABEL_NAVIGATE_TO_LOGIN')}
			</Button>
		</Notice>
	</Card>);
};

export default StyleDecorator(Radium(ChangeEmailSuccessApp));



// WEBPACK FOOTER //
// ./src/ChangeEmailSuccessApp.js